import CustomModal from '@/components/CustomModal';
import styles from '../index.less';

export default function HistoryCashModal({ visible, onClose, cashNum = '--', title }) {
  return (
    <CustomModal visible={visible} okCallback={onClose} title={title}>
      <div className={styles.historyCashModal}>
        <h4 className={styles.historyCashTitle}>{cashNum || '--'}</h4>
        <p className={styles.historyCashDesc}>
          *该设备历史获得的现金如上，您设备后续获得的云豆收益，仍可在商城按照100：1兑换现金或者兑换其他商品
        </p>
      </div>
    </CustomModal>
  );
}
